import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { BackButton } from "@/shared/ui/back-button"

// Финальные welcome-экраны (signup после даты рождения, signin после
// логина) — единственные онбординговые роуты, на которых пользователь уже
// authenticated; дальше они сами уводят на /home через корневой index.
const AUTHENTICATED_ALLOWED_PATHS = new Set([
	"/onboarding/signup-welcome",
	"/onboarding/signin-welcome",
])

export const Route = createFileRoute("/onboarding")({
	beforeLoad: ({ context, location }) => {
		if (
			context.isAuthenticated &&
			!AUTHENTICATED_ALLOWED_PATHS.has(location.pathname)
		) {
			throw redirect({ to: "/home", replace: true })
		}
	},
	component: OnboardingLayout,
})

function OnboardingLayout() {
	return (
		<>
			<Outlet />
			<BackButton floating />
		</>
	)
}
